import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { MyAccountEmptyListViewStore } from 'common/module/my-account/empty-list/view-store';

import { UserAuthenticationService } from '../user-authentication/service';

const service = new MyAccountEmptyListViewStore(EventEmitterFactory(), UserAuthenticationService());

export function MyAccountEmptyListViewStoreService(): MyAccountEmptyListViewStore {
  return service;
}
